import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import Tag from "../Tag";
import styles from "./styles.module.scss";

const TagList = ({ tags, displayKey, onRemove, className }) => {
  const ref = useRef([]);
  useEffect(() => {
    // scroll to right so last tag is in view
    const width = [...ref.current.children].reduce(
      (tot, el) => tot + el.offsetWidth,
      0
    );
    ref.current.scroll({ left: width, behavior: "smooth" });
  }, [tags]);

  return (
    <div
      className={cn(styles.tagList, className, {
        [styles.empty]: !tags.length,
      })}
      ref={(el) => {
        ref.current = el;
      }}
    >
      {tags.map((tag) => (
        <Tag
          key={tag[displayKey]}
          id={tag.id}
          title={tag[displayKey]}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onRemove: PropTypes.func,
  displayKey: PropTypes.string,
  className: PropTypes.string,
};
TagList.defaultProps = {
  onRemove: null,
  displayKey: "name",
  className: null,
};

export default TagList;
